export type GraphProps = {
  title: {
    text?: string;
    textStyle?: { color: string; fontSize: number; fontFamily?: string };
    left?: string;
    top?: string;
    itemGap?: number;
    subtext?: string;
    subtextStyle?: { fontSize: number };
  };
  series: {
    type?: string;
    name?: string;
    radius?: string[];
    avoidLabelOverlap?: boolean;
    tooltip?: { show: boolean };
    color?: string[];
    label?: {
      show?: boolean;
      position?: string;
    };
    emphasis?: { disabled: boolean };
    labelLine?: {
      show?: boolean;
    };
    data?: { value: number; name: string }[];
  }[];
};

export const graphOptions = (graphData: GraphProps) => {
  return {
    title: {
      text: graphData.title.text,
      textStyle: {
        color: graphData.title.textStyle?.color,
        fontSize: graphData.title.textStyle?.fontSize,
        fontFamily: graphData.title.textStyle?.fontFamily,
      },
      left: 'center',
      top: 'middle',
      itemGap: 1,
      subtext: graphData.title.subtext,
      subtextStyle: { fontSize: 10 },
    },
    series: [
      {
        type: 'pie',
        name: 'Health',
        radius: ['90%', '100%'],
        avoidLabelOverlap: false,
        tooltip: { show: false },
        color: graphData.series[0].color,
        label: {
          show: false,
        },
        emphasis: { disabled: true },
        labelLine: {
          show: false,
        },
        data: graphData.series[0].data,
      },
    ],
  };
};
